import alerts from '@/alerts/alert'
import AuthenticationService from '@/services/AuthenticationService'
import store from '@/store'
import router from '@/router'

const auth = {
  namespaced: true,
  state: {
    dialogFormLogin: false,
    formAuth: {
      name: '',
      email: '',
      password: '',
      phone: ''
    },
    dialogFormRegister: false,
    user: null,
    captcha: {
      image: '',
      key: '',
      value: ''
    },
    dialogProfile: false,
    logo: require('@/assets/img/HR_One_Logo.png'),
    logo_white: require('@/assets/img/HR_One_White.png')
  },
  getters: {
    getCaptcha (state) {
      return state.banner
    },
    user (state) {
      return state.user
    }
  },
  mutations: {
    SET_DIALOG_LOGIN (state, payload) {
      state.dialogFormLogin = payload
    },
    SET_CAPTCHA (state, captcha) {
      state.captcha = captcha
    },
    SET_USER (state, user) {
      state.user = user
    },
    SET_LOGOUT (state) {
      if (state.user) {
        alerts.sweetalertToast('success', 'Berhasil Logout')
      }
      localStorage.removeItem('auth-user-state')
      localStorage.removeItem('user-persist-state')
      state.user = null
      state.dialogProfile = false
      window.location = '/'
      // router.push({ name: 'PublicPage' })
    }
  },
  actions: {
    async dialogFormLogin ({ commit, state }, payload) {
      commit('SET_DIALOG_LOGIN', payload)
      // return await AuthenticationService.get('captcha/flat').then(({ data }) => {
      //   state.captcha.image = data.img
      //   state.captcha.key = data.key
      // })
    },
    async reqCaptchaNew ({ state }, payload) {
      return await AuthenticationService.get(`captcha/${payload}`).then(({ data }) => {
        state.captcha.image = data.img
        state.captcha.key = data.key
      })
    },
    async validate ({ commit, state }) {
      store.dispatch('loading/setLoadingDefault', true)
      const params = {
        username: state.formAuth.email,
        password: state.formAuth.password,
        remember_me: true,
        cm_token: 'dLl_CAYQSbetQ5UrlPXxIC:APA91bHOA-dim_ASBzZqmu3DxtG1F0He4FLpEYWGzFMErGkjrmOS6ulC0kX19psYLVovPmhLS_nLyIh-1REOf5QZy8zZQRxBGbZT_EXIUBxk5HDmE99F-SULUKAiD3SyHwWS3AlSEhl7'
      }
      return await AuthenticationService.post('auth/login', params).then(({ data }) => {
        // console.log('Gagal Di tambahkan', JSON.stringify(data))
        store.dispatch('loading/setLoadingDefault', false)
        if (data.code === 200) {
          commit('SET_USER', data.data)
          state.dialogFormLogin = false
          alerts.sweetalertToast('success', 'Login Berhasil')
          router.push({ name: 'Home' })
        } else {
          alerts.sweetalertToast('error', data.message)
        }
      }).catch(error => {
        store.dispatch('loading/setLoadingDefault', false)
        alerts.sweetalertToast('error', error.response.data.message)
        // console.log('Gagal Di tambahkan', error.response)
      })
    },
    reqLogout ({ commit }) {
      commit('SET_LOGOUT')
    }
  }
}

export default auth
